import { Skeleton, Stack, Typography } from "@mui/material"

interface Props {
    message?: string
}

export default function LaodingBoxComponent({ message = 'Loading...' }: Props) {
    return (
        <Stack spacing={1}>
            {/* For variant="text", adjust the height via font-size */}
            <Skeleton variant="text" sx={{ fontSize: '1.2rem' }} />
            <Typography variant='h6' sx={{ justifyContent: "center", color: '#f1f1f1', pl: 2}}>{message}</Typography>
            {/* For other variants, adjust the size with `width` and `height` */}          
            <Skeleton variant="rectangular" width='100%' height={60} />
            <Skeleton variant="rounded" width='100%' height={60} />
        </Stack>
    )
}